module.exports = __webpack_public_path__ + "static/media/project.25b20ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project.jpg
// module id = 5826
// module chunks = 0